<template>
  <button
    class="btn btn--cancel"
    type="button"
    @click.self="handleCancel"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'CancelButton',
  methods: {
    handleCancel() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn--cancel {
  display: flex;
  height: 40px;
  box-sizing: border-box;
  flex: 1;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 202, 39, 100%);
  border-radius: 20px;
  color: #000;
  font-size: 14px;
  line-height: 38px;
  text-align: center;

  &:hover {
    background: #ffefbf;
  }

  &:active {
    border-color: #b28d1b;
    background: #b28d1b;
  }
}
</style>